angular.module("avant.customer_applications.directives").directive "showInArray", ->

  scope:
    showInArray: '@'

    showInArrayValuesJson: '&'
    showInArrayValues: '&'

    showInArrayErrors: '&'
    showInArrayErrorsRequirements: '&'

    showInArrayShowKey: '='

  link: ($scope, element, attributes) ->

    # returns true if a server side error applies to a required child field of the directive element
    errorInRequirements = (errors, requirements) ->
      return false if (!requirements || !errors || errors.length == 0)
      required_errors = _.intersection(requirements, errors)
      required_errors.length > 0

    runHideShowLogic = (value, errors) ->
      if _.contains(values, value) || errorInRequirements(errors, $scope.showInArrayErrorsRequirements())
        $scope.showInArrayShowKey = true
      else
        $scope.showInArrayShowKey = false

    values = []
    if $scope.showInArrayValuesJson()
      values = $scope.showInArrayValuesJson()
    else
      $scope.$watch $scope.showInArrayValues, ((newValue) ->
        if _.isArray(newValue)
          values = newValue
          runHideShowLogic($scope.showInArray, $scope.showInArrayErrors())
      ), true

    runHideShowLogic($scope.showInArray, $scope.showInArrayErrors())

    watchValues = {}
    $scope.$watch (->
      watchValues.showInArray = $scope.showInArray
      watchValues.showInArrayErrors = $scope.showInArrayErrors()
      watchValues
    ), ((newValue, oldValue) ->
      return if newValue is oldValue
      runHideShowLogic newValue.showInArray, newValue.showInArrayErrors
      return
    ), true

  restrict: "A"
